import Button from '@components/Button';
import { PrepaidCardGiftBoxResponse } from '@models/prepaidCard';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import useRegisterPrepaidGift from '../../hooks/useRegisterPrepaidGift';

interface Props {
    gift: PrepaidCardGiftBoxResponse;
}

function GiftDetailFooter({ gift }: Props) {
    const { t } = useTranslation('prepaidCard');
    const { mutate, isPending } = useRegisterPrepaidGift(gift.id);

    if (gift.status === 'ISSUED') {
        return (
            <Button fullWidth
                disabled={isPending}
                onClick={() => mutate()}>
                {t('giftDetail.register')}
            </Button>
        );
    }

    if (gift.status === 'USED' && gift.registeredAt) {
        return (
            <Button fullWidth variant='tone' size='medium' disabled>
                {t('giftDetail.registeredAt', {
                    date: dayjs(gift.registeredAt).format('YY.MM.DD'),
                })}
            </Button>
        );
    }

    if (gift.status === 'CANCELED' && gift.canceledAt) {
        return (
            <Button fullWidth variant='tone' size='medium' disabled>
                {t('giftDetail.canceledAt', {
                    date: dayjs(gift.canceledAt).format('YY.MM.DD'),
                })}
            </Button>
        );
    }

    if (gift.status === 'USED') {
        return (
            <Button fullWidth variant='tone' size='medium' disabled>
                {t('giftBox.status.USED')}
            </Button>
        );
    }

    if (gift.status === 'CANCELED') {
        return (
            <Button fullWidth variant='tone' size='medium' disabled>
                {t('giftBox.status.CANCELED')}
            </Button>
        );
    }

    return null;
}

export default GiftDetailFooter;
